import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { GraphQLResponse } from '../types';

const getPayrollCycleQuery = gql`
  query PayrollGetMonthFromDate($date: String!) {
    payrollGetMonthFromDate(date: $date) {
      code
      success
      message
      data {
        payrollMonth
      }
    }
  }
`;

type PayrollGetMonthFromDateRequest = {
  date: string;
};

export type PayrollGetMonthFromDateResponse = GraphQLResponse<
  'payrollGetMonthFromDate',
  { payrollMonth: string }
>;

const getPayrollMonthFromDate = (request: PayrollGetMonthFromDateRequest) => {
  if (request.date) {
    return graphQLApi<PayrollGetMonthFromDateResponse, PayrollGetMonthFromDateRequest>({
      query: getPayrollCycleQuery,
      queryVariables: request,
    });
  } else {
    return Promise.reject('UserID and PayrollMonth are both required');
  }
};

export default {
  getPayrollMonthFromDate,
};
